import { styled } from "@mui/material";
import { Tabs, Tab } from "@mui/material";

export const StyledTabs = styled(Tabs)(({ isPanelOpen }) => ({
  "& .MuiTabs-indicator": {
    backgroundColor: "#1890ff",
  },
  ...(isPanelOpen === false && {
    "& .MuiTabs-flexContainer": {
      gap: 60,
      alignItems: "center",
    },
  }),
}));

export const StyledTab = styled(({ isPanelOpen, ...props }) => (
  <Tab disableRipple {...props} />
))(({ theme, isPanelOpen }) => ({
  textTransform: "capitalize",
  minHeight: "48px",
  ...(isPanelOpen === false && {
    transform: "rotate(-90deg)",
  }),
}));
